module.exports = __webpack_public_path__ + "img/18.fcea9ef0.svg";